import { cn } from "@/lib/utils";
import { To, useNavigate } from "react-router-dom";

interface NavLinkContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    to: To;
    disabled?: boolean;
}

function getAbsoluteUrl(to: To): string {
    if (typeof to === "string") {
        return to.startsWith("http") ? to : `${window.location.origin}${to.startsWith("/") ? to : `/${to}`}`;
    }
    const pathname = to.pathname ?? "";
    const search = to.search ?? "";
    const hash = to.hash ?? "";
    return `${window.location.origin}${pathname}${search}${hash}`;
}

export function NavLinkContainer({ to, className, disabled = false, children, onClick, ...props }: NavLinkContainerProps) {
    const navigate = useNavigate();
    if (disabled) {
        return <div className={className}>{children}</div>;
    }
    return (
        <div
            className={cn("cursor-pointer", className)}
            onClick={event => {
                if (event.metaKey || event.ctrlKey) {
                    const win = window.open(getAbsoluteUrl(to), "_blank");
                    win?.focus();
                } else {
                    const toStr = typeof to === "string" ? to : undefined;
                    const isAbsoluteUrl = toStr !== undefined && /^https?:\/\//i.test(toStr);
                    if (isAbsoluteUrl && toStr) {
                        try {
                            const url = new URL(toStr);
                            if (url.origin === window.location.origin) {
                                navigate(url.pathname + url.search + url.hash);
                            } else {
                                window.open(toStr, "_blank")?.focus();
                            }
                        } catch {
                            navigate(to);
                        }
                    } else {
                        navigate(to);
                    }
                }
                onClick?.(event);
            }}
            {...props}
        >
            {children}
        </div>
    );
}
